import { useQuery } from '@tanstack/react-query';

export function useDriversQuery(api, orgId, authToken) {
  return useQuery({
    queryKey: ['drivers', orgId],
    queryFn: () => api.drivers.getAll(orgId, authToken),
    enabled: Boolean(api && orgId && authToken),
  });
}
